import { logger } from '../../../utils/logger'
import type { ServiceHandler } from './service-registry'
import { getCampaignProgressMetrics as getCampaignProgressMetricsService } from '../../../services/campaign'
import type {
  GetCampaignProgressRequest,
  GetCampaignProgressResponse,
} from '@custom-embedded-code-sdk/methods/get-campaign-progress'

/**
 * GET_CAMPAIGN_PROGRESS_METRICS service handler
 *
 * Handles requests to retrieve campaign progress metrics for the current campaign.
 */
export const getCampaignProgressMetrics: ServiceHandler<
  GetCampaignProgressRequest,
  GetCampaignProgressResponse
> = async ({
  iframeId,
  messageId,
  sendSuccessResponse,
  sendErrorResponse,
  pageConfig: { campaignId },
}) => {
  try {
    if (!campaignId) {
      throw new Error('CustomEmbeddedCode:getCampaignProgressMetrics: Campaign ID not available')
    }

    const progressMetricsData = await getCampaignProgressMetricsService(campaignId)

    sendSuccessResponse(iframeId, messageId, progressMetricsData)
  } catch (error) {
    logger(
      'error',
      new Error(
        'CustomEmbeddedCode:getCampaignProgressMetrics: Failed to get campaign progress metrics',
        {
          cause: error,
        },
      ),
      {
        context: { iframeId, messageId, campaignId },
      },
    )

    sendErrorResponse(
      iframeId,
      messageId,
      'CustomEmbeddedCode:getCampaignProgressMetrics: Unable to get campaign progress metrics',
    )
  }
}
